import { render, staticRenderFns } from "./kcheckbox.vue?vue&type=template&id=23c7a1d2"
import script from "./kcheckbox.vue?vue&type=script&lang=js"
export * from "./kcheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports